
// import React, { useState, useRef } from 'react'; // Added useRef here
// import { Search, Calendar, User, ArrowRight, Clock } from 'lucide-react';
// import heroimage from "../assets/blogs.webp";
// import postImage1 from "../assets/pricing.avif"
// import postImage2 from "../assets/blogs2.webp"
// import postImage3 from "../assets/blogs3.jpg"
// import postImage4 from "../assets/blogs4.webp"
// import postImage5 from "../assets/blogs5.webp"
// import postImage6 from "../assets/blogs6.webp"
// import postImage7 from "../assets/blogs7.webp"
// import postImage8 from "../assets/blogs8.webp"
// import postImage9 from "../assets/blogs9.webp"

// const BLOG_POSTS = [
//   {
//     id: 1,
//     title: "The Future of SMS Marketing in 2026",
//     excerpt: "Discover why Bulk SMS remains the highest ROI channel for businesses despite the rise of instant messaging apps.",
//     category: "Marketing Strategy",
//     author: "Alex Morgan",
//     date: "Jan 10, 2026",
//     readTime: "5 min read",
//     image: postImage1
//   },
//   {
//     id: 2,
//     title: "DLT Registration: A Complete Guide",
//     excerpt: "Navigating the new regulations for Bulk SMS can be tricky. Here is your step-by-step guide to DLT compliance.",
//     category: "Compliance",
//     author: "Sarah Jenkins",
//     date: "Jan 08, 2026",
//     readTime: "8 min read",
//     image: postImage2
//   },
//   {
//     id: 3,
//     title: "Transactional vs. Promotional SMS",
//     excerpt: "Understanding the critical differences between route types to ensure your OTPs deliver instantly.",
//     category: "Technical",
//     author: "David Chen",
//     date: "Jan 05, 2026",
//     readTime: "4 min read",
//     image: postImage3
//   },
//   {
//     id: 4,
//     title: "Boosting Customer Retention with SMS",
//     excerpt: "Learn how personalized automated SMS triggers can increase your customer lifetime value by 30%.",
//     category: "Growth",
//     author: "Emily White",
//     date: "Dec 28, 2025",
//     readTime: "6 min read",
//     image: postImage4
//   },
//   {
//     id: 5,
//     title: "API Integration Best Practices",
//     excerpt: "How to seamlessly integrate our Bulk SMS API into your existing CRM or ERP software.",
//     category: "Development",
//     author: "Michael Ross",
//     date: "Dec 22, 2025",
//     readTime: "10 min read",
//     image: postImage5
//   },
//   {
//     id: 6,
//     title: "SMPP Protocol: The Backbone of High-Volume SMS",
//     excerpt: "Why enterprises choose SMPP over HTTP for massive campaigns. Achieve lower latency and continuous throughput for critical messaging.",
//     category: "Infrastructure",
//     author: "Robert Fox",
//     date: "Dec 15, 2025",
//     readTime: "6 min read",
//     image: postImage6
//   },
//   // --- UPDATED BLOG POSTS (7 & 8) ---
//   {
//     id: 7,
//     title: "HTTP API vs. SMPP Protocol: Which is Best for Your Bulk SMS Needs?",
//     excerpt: "Choosing the right connectivity is crucial for scale. We break down the technical differences between HTTP APIs for simplicity and SMPP for high-throughput enterprise needs.",
//     category: "Technical Comparison",
//     author: "James Wilson",
//     date: "Dec 10, 2025",
//     readTime: "7 min read",
//     image: postImage7
//   },
//   {
//     id: 8,
//     title: "Timing is Everything: The Best Times to Send Promotional Bulk SMS",
//     excerpt: "Maximize your open rates by hitting the inbox at the perfect moment. Analyze customer behavior patterns to discover the golden hours for promotional campaigns.",
//     category: "Marketing Tips",
//     author: "Priya Patel",
//     date: "Dec 05, 2025",
//     readTime: "5 min read",
//     image: postImage8
//   },
//   {
//     id: 9,
//     title: "SMS vs. Email Marketing: A 2025 Comparison",
//     excerpt: "While email is great for newsletters, SMS boasts a 98% open rate. We analyze data from 500+ campaigns to help you allocate your budget effectively.",
//     category: "Analytics",
//     author: "Marcus Johnson",
//     date: "Nov 28, 2025",
//     readTime: "9 min read",
//     image: postImage9
//   }
// ];

// export const Blogs = () => {
//   const [searchTerm, setSearchTerm] = useState('');
  
//   // NEW: Ref to scroll to the results section
//   const resultsRef = useRef(null);

//   // Filter posts based on search
//   const filteredPosts = BLOG_POSTS.filter(post => 
//     post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     post.category.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // NEW: Function to handle scroll logic
//   const handleSearchScroll = () => {
//     if (resultsRef.current) {
//       resultsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     }
//   };

//   // NEW: Handle Enter key press
//   const handleKeyDown = (e) => {
//     if (e.key === 'Enter') {
//       handleSearchScroll();
//     }
//   };

//   // Custom style for the 3D text effect
//   const premium3DTextStyle = {
//     textShadow: '0 1px 0 #ccc, 0 2px 0 #c9c9c9, 0 3px 0 #bbb, 0 4px 0 #b9b9b9, 0 5px 0 #aaa, 0 6px 1px rgba(0,0,0,.1), 0 0 5px rgba(0,0,0,.1), 0 1px 3px rgba(0,0,0,.3), 0 3px 5px rgba(0,0,0,.2), 0 5px 10px rgba(0,0,0,.25), 0 10px 10px rgba(0,0,0,.2), 0 20px 20px rgba(0,0,0,.15)',
//   };

//   return (
//     <div className="min-h-screen bg-[#EEF2FC] font-sans">
      
//       {/* --- HERO SECTION --- */}
//       <div className="relative w-full h-[400px] md:h-[500px] overflow-hidden">
//         {/* Image Layer */}
//         <div className="absolute inset-0">
//           <img 
//             src={heroimage} 
//             alt="Blog Hero" 
//             className="w-full h-full object-cover"
//           />
//           {/* Subtlety gradient only at the very bottom for smooth transition, keeping image clear */}
//           <div className="absolute inset-0 bg-gradient-to-t from-gray-50/30 via-transparent to-transparent"></div>
//         </div>

//         {/* Hero Content - Centered Heading Only */}
//         <div className="relative z-10 h-full flex flex-col justify-center items-center px-4">
//            <h1 
//              className="text-7xl md:text-9xl font-extrabold tracking-tight text-white uppercase text-center animate-pulse"
//              style={premium3DTextStyle}
//            >
//              BLOGS
//            </h1>
//         </div>
//       </div>

//       {/* --- SEARCH SECTION --- */}
//       {/* Negative margin pulls it up slightly to bridge hero and content */}
//       <div className="relative z-20 -mt-8 px-4 sm:px-6 lg:px-8">
//         <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-lg p-2 flex items-center border border-gray-100">
//           <div className="pl-4 text-gray-400">
//             <Search size={24} />
//           </div>
//           <input 
//             type="text"
//             placeholder="Search for articles, guides, or topics..."
//             className="w-full px-4 py-3 text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-0 text-lg rounded-lg"
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             onKeyDown={handleKeyDown} // Added enter key support
//           />
//           <button 
//             onClick={handleSearchScroll} // Added click handler
//             className="hidden sm:block bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-3 rounded-lg font-medium transition-colors"
//           >
//             Search
//           </button>
//         </div>
//       </div>

//       {/* --- BLOG GRID SECTION --- */}
//       {/* Attached the REF to this div so it scrolls here */}
//       <div ref={resultsRef} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        
//         {/* Section Header */}
//         <div className="flex justify-between items-end mb-12">
//           <div>
//             <h2 className="text-3xl font-bold text-gray-900">Latest Updates</h2>
//             <p className="text-gray-600 mt-2 text-lg">Dive into bulk messaging topics, explore industry trends, and learn how impactful SMS communication strengthens your bottom line.</p>
//           </div>
//         </div>

//         {/* Grid */}
//         {filteredPosts.length > 0 ? (
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
//             {filteredPosts.map((post) => (
//               <article 
//                 key={post.id} 
//                 className="group bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
//               >
//                 {/* Card Image */}
//                 <div className="relative h-48 overflow-hidden">
//                   <img 
//                     src={post.image} 
//                     alt={post.title} 
//                     className="w-full h-full object-cover transform transition-transform duration-500"
//                   />
//                   <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-indigo-600 uppercase tracking-wide">
//                     {post.category}
//                   </div>
//                 </div>

//                 {/* Card Content */}
//                 <div className="p-6">
//                   {/* Meta Data */}
//                   <div className="flex items-center text-gray-400 text-xs mb-4 space-x-4">
//                     <div className="flex items-center">
//                       <Calendar size={14} className="mr-1" />
//                       {post.date}
//                     </div>
//                     <div className="flex items-center">
//                       <Clock size={14} className="mr-1" />
//                       {post.readTime}
//                     </div>
//                   </div>

//                   <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-indigo-600 transition-colors line-clamp-2">
//                     {post.title}
//                   </h3>
                  
//                   <p className="text-gray-500 text-sm leading-relaxed mb-6 line-clamp-3">
//                     {post.excerpt}
//                   </p>

//                   <div className="flex items-center justify-between border-t border-gray-100 pt-4">
//                     <div className="flex items-center">
//                       <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-500">
//                         <User size={16} />
//                       </div>
//                       <span className="ml-2 text-sm font-medium text-gray-700">{post.author}</span>
//                     </div>
                    
//                     <button className="text-indigo-600 font-semibold text-sm flex items-center hover:translate-x-1 transition-transform">
//                       Read More <ArrowRight size={16} className="ml-1" />
//                     </button>
//                   </div>
//                 </div>
//               </article>
//             ))}
//           </div>
//         ) : (
//           <div className="text-center py-20">
//             <h3 className="text-xl text-gray-600">No articles found matching "{searchTerm}"</h3>
//             <button 
//               onClick={() => setSearchTerm('')}
//               className="mt-4 text-indigo-600 font-medium hover:underline"
//             >
//               Clear search
//             </button>
//           </div>
//         )}
//       </div>

//       {/* --- NEWSLETTER SECTION (Professional Touch) --- */}
//       <div className="bg-indigo-900 py-16">
//         <div className="max-w-4xl mx-auto px-4 text-center">
//           <h2 className="text-3xl font-bold text-white mb-4">Subscribe to our newsletter</h2>
//           <p className="text-indigo-200 mb-8">Get the latest SMS marketing tips and industry news delivered to your inbox.</p>
//           <div className="flex flex-col sm:flex-row gap-3 justify-center max-w-lg mx-auto">
//             <input 
//               type="email" 
//               placeholder="Enter your email" 
//               className="px-5 py-3 rounded-lg text-gray-900 focus:outline-none w-full"
//             />
//             <button className="bg-white text-indigo-900 font-bold px-8 py-3 rounded-lg hover:bg-indigo-50 transition-colors">
//               Subscribe
//             </button>
//           </div>
//         </div>
//       </div>

//     </div>
//   )
// }


import React, { useState, useRef, useEffect } from 'react';
import { Search, Calendar, User, ArrowRight, Clock, X } from 'lucide-react';
import heroimage from "../assets/blogs.webp";
import postImage1 from "../assets/pricing.webp"
import postImage2 from "../assets/blogs2.webp"
import postImage3 from "../assets/blogs3.webp"
import postImage4 from "../assets/blogs4.webp"
import postImage5 from "../assets/blogs5.webp"
import postImage6 from "../assets/blogs6.webp"
import postImage7 from "../assets/blogs7.webp"
import postImage8 from "../assets/blogs8.webp"
import postImage9 from "../assets/blogs9.webp"

const BLOG_POSTS = [
  {
    id: 1,
    title: "The Future of SMS Marketing in 2026",
    excerpt: "Discover why Bulk SMS remains the highest ROI channel for businesses despite the rise of instant messaging apps.",
    category: "Marketing Strategy",
    author: "Alex Morgan",
    date: "Jan 10, 2026",
    readTime: "5 min read",
    image: postImage1,
    content: {
      sub1: "Hyper-Personalization via AI",
      body1: "In 2026, AI-driven engines analyze real-time user behavior to send SMS content that feels like a 1-on-1 conversation, significantly boosting conversion rates.",
      sub2: "The Rise of RCS Messaging",
      body2: "Rich Communication Services is transforming text into an app-like experience with high-res carousels and live buttons directly within the native messaging app.",
      sub3: "Zero-Party Data Collection",
      body3: "As privacy laws tighten, SMS has become the primary tool for gathering compliant zero-party data through interactive keyword responses.",
      sub4: "Send-Time Optimization",
      body4: "Advanced algorithms now predict the exact minute a user is likely to check their phone, ensuring your message sits at the top of the inbox."
    }
  },
  {
    id: 2,
    title: "DLT Registration: A Complete Guide",
    excerpt: "Navigating the new regulations for Bulk SMS can be tricky. Here is your step-by-step guide to DLT compliance.",
    category: "Compliance",
    author: "Sarah Jenkins",
    date: "Jan 08, 2026",
    readTime: "8 min read",
    image: postImage2,
    content: {
      sub1: "The DLT Ecosystem",
      body1: "Distributed Ledger Technology is a blockchain system mandated by TRAI to track every message and sender to eliminate spam effectively.",
      sub2: "Entity Registration",
      body2: "The first step involves registering your business as a Principal Entity to claim your unique 6-character Header (Sender ID).",
      sub3: "Content Templates",
      body3: "Every message sent must match a pre-approved template. Ensure your variables are correctly placed to avoid system rejection.",
      sub4: "Consent Management",
      body4: "Maintaining a digital record of customer consent is now mandatory. Your portal allows you to manage 'scrubbable' lists to stay compliant."
    }
  },
  {
    id: 3,
    title: "Transactional vs. Promotional SMS",
    excerpt: "Understanding the critical differences between route types to ensure your OTPs deliver instantly.",
    category: "Technical",
    author: "David Chen",
    date: "Jan 05, 2026",
    readTime: "4 min read",
    image: postImage3,
    content: {
      sub1: "Defining the Routes",
      body1: "Transactional routes are for critical alerts like OTPs, while Promotional routes are strictly for marketing and brand offers.",
      sub2: "Delivery Priority",
      body2: "Transactional SMS delivers 24/7 with the highest network priority. Promotional SMS is restricted to specific 'working hours'.",
      sub3: "Sender ID Architecture",
      body3: "Transactional messages typically use alphabetic headers, whereas promotional messages are often assigned numeric headers.",
      sub4: "Compliance Filtering",
      body4: "Mixing content types is a common mistake. Sending promotions through a transactional pipe can result in heavy fines."
    }
  },
  {
    id: 4,
    title: "Boosting Customer Retention with SMS",
    excerpt: "Learn how personalized automated SMS triggers can increase your customer lifetime value by 30%.",
    category: "Growth",
    author: "Emily White",
    date: "Dec 28, 2025",
    readTime: "6 min read",
    image: postImage4,
    content: {
      sub1: "Post-Purchase Sequences",
      body1: "Use automated SMS to send 'Thank You' notes and care instructions immediately after a sale to build trust.",
      sub2: "Win-Back Campaigns",
      body2: "Identify customers who haven't purchased in 60 days. A timely discount code via SMS has a high recovery rate.",
      sub3: "VIP Loyalty Alerts",
      body3: "Send early-access links for new launches to your best customers to create an emotional connection and loyalty.",
      sub4: "Instant Feedback",
      body4: "SMS surveys see response rates of up to 30%. Short links allow you to resolve issues before they become public."
    }
  },
  {
    id: 5,
    title: "API Integration Best Practices",
    excerpt: "How to seamlessly integrate our Bulk SMS API into your existing CRM or ERP software.",
    category: "Development",
    author: "Michael Ross",
    date: "Dec 22, 2025",
    readTime: "10 min read",
    image: postImage5,
    content: {
      sub1: "Secure Authentication",
      body1: "Always use API keys hidden in environment variables. Implement IP whitelisting for high-security environments.",
      sub2: "Error Handling",
      body2: "Build logic to handle responses like 'Rate Limit Exceeded'. Implement an exponential backoff strategy for retries.",
      sub3: "Asynchronous Webhooks",
      body3: "Use Webhooks to receive real-time Delivery Receipts. This keeps your database updated without straining resources.",
      sub4: "Batch Processing",
      body4: "When sending thousands of messages, use batch endpoints to reduce the number of HTTP requests and optimize throughput."
    }
  },
  {
    id: 6,
    title: "SMPP Protocol: The Backbone of High-Volume SMS",
    excerpt: "Why enterprises choose SMPP over HTTP for massive campaigns. Achieve lower latency and continuous throughput for critical messaging.",
    category: "Infrastructure",
    author: "Robert Fox",
    date: "Dec 15, 2025",
    readTime: "6 min read",
    image: postImage6,
    content: {
      sub1: "Binary Protocol Power",
      body1: "SMPP is a specialized protocol designed for SMS, offering lower overhead than standard text-based HTTP.",
      sub2: "Persistent Connections",
      body2: "SMPP maintains a 'bind' connection, allowing for thousands of messages per second with nearly zero latency.",
      sub3: "Full-Duplex Comms",
      body3: "This protocol allows you to send messages and receive delivery reports simultaneously over the same link.",
      sub4: "Enterprise Scaling",
      body4: "While complex to implement, SMPP is essential for businesses sending over 5 million messages per month."
    }
  },
  {
    id: 7,
    title: "HTTP API vs. SMPP Protocol: Which is Best for Your Bulk SMS Needs?",
    excerpt: "Choosing the right connectivity is crucial for scale. We break down the technical differences between HTTP APIs for simplicity and SMPP for high-throughput enterprise needs.",
    category: "Technical Comparison",
    author: "James Wilson",
    date: "Dec 10, 2025",
    readTime: "7 min read",
    image: postImage7,
    content: {
      sub1: "Integration Speed",
      body1: "HTTP APIs can be integrated in minutes. SMPP requires deeper networking expertise but offers higher scaling performance.",
      sub2: "Scalability Benchmarks",
      body2: "HTTP is excellent for thousands of messages; SMPP is built for millions of time-sensitive global alerts.",
      sub3: "Security Standards",
      body3: "Both support encryption, but SMPP’s direct connection to the SMSC provides a robust path for sensitive data.",
      sub4: "Making the Choice",
      body4: "Start with HTTP for flexibility. Transition to SMPP when sub-second delivery for massive volumes is non-negotiable."
    }
  },
  {
    id: 8,
    title: "Timing is Everything: The Best Times to Send Promotional Bulk SMS",
    excerpt: "Maximize your open rates by hitting the inbox at the perfect moment. Analyze customer behavior patterns to discover the golden hours for promotional campaigns.",
    category: "Marketing Tips",
    author: "Priya Patel",
    date: "Dec 05, 2025",
    readTime: "5 min read",
    image: postImage8,
    content: {
      sub1: "Mid-Morning Peak",
      body1: "Engagement peaks between 10:30 AM and 11:30 AM after people have cleared their initial morning emails.",
      sub2: "Avoid Commute Hours",
      body2: "Never send promotional SMS during morning or evening commutes when users are too overwhelmed to take action.",
      sub3: "Weekend Strategy",
      body3: "Saturdays between 11 AM and 1 PM are excellent for retail brands, while Sundays should generally be avoided.",
      sub4: "Local Time Sync",
      body4: "Ensure the message arrives at the recipient's local 'Golden Hour' rather than your server's local time."
    }
  },
  {
    id: 9,
    title: "SMS vs. Email Marketing: A 2025 Comparison",
    excerpt: "While email is great for newsletters, SMS boasts a 98% open rate. We analyze data from 500+ campaigns to help you allocate your budget effectively.",
    category: "Analytics",
    author: "Marcus Johnson",
    date: "Nov 28, 2025",
    readTime: "9 min read",
    image: postImage9,
    content: {
      sub1: "Open Rate Reality",
      body1: "SMS open rates hover at 98%, with most read within 3 minutes. Email is better for long-form detailed information.",
      sub2: "Urgency vs. Depth",
      body2: "Use Email for storytelling and long educational content. Use SMS for flash sales and urgent time-sensitive alerts.",
      sub3: "ROI Analysis",
      body3: "Email is cheaper per unit, but SMS offers a significantly higher ROI per engagement for final sale closures.",
      sub4: "The Hybrid Model",
      body4: "Successful strategies use Email for the top of the funnel and SMS follow-ups for those who clicked but didn't buy."
    }
  }
];

export const Blogs = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedPost, setSelectedPost] = useState(null);
  const resultsRef = useRef(null);

  useEffect(() => {
    if (selectedPost) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => { document.body.style.overflow = 'unset'; };
  }, [selectedPost]);

  const filteredPosts = BLOG_POSTS.filter(post => 
    post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    post.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSearchScroll = () => {
    if (resultsRef.current) {
      resultsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearchScroll();
    }
  };

  const premium3DTextStyle = {
    textShadow: '0 1px 0 #ccc, 0 2px 0 #c9c9c9, 0 3px 0 #bbb, 0 4px 0 #b9b9b9, 0 5px 0 #aaa, 0 6px 1px rgba(0,0,0,.1), 0 0 5px rgba(0,0,0,.1), 0 1px 3px rgba(0,0,0,.3), 0 3px 5px rgba(0,0,0,.2), 0 5px 10px rgba(0,0,0,.25), 0 10px 10px rgba(0,0,0,.2), 0 20px 20px rgba(0,0,0,.15)',
  };

  return (
    <div className="min-h-screen bg-[#EEF2FC] font-sans">
      
      {/* --- HERO SECTION (RESTORED EXACTLY) --- */}
      <div className="relative w-full h-[400px] md:h-[500px] overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src={heroimage} 
            alt="Blog Hero" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-gray-50/30 via-transparent to-transparent"></div>
        </div>
        <div className="relative z-10 h-full flex flex-col justify-center items-center px-4">
           <h1 
             className="text-7xl md:text-9xl font-extrabold tracking-tight text-white uppercase text-center animate-pulse"
             style={premium3DTextStyle}
           >
             BLOGS
           </h1>
        </div>
      </div>

      {/* --- SEARCH SECTION (RESTORED EXACTLY) --- */}
      <div className="relative z-20 -mt-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-lg p-2 flex items-center border border-gray-100">
          <div className="pl-4 text-gray-400">
            <Search size={24} />
          </div>
          <input 
            type="text"
            placeholder="Search for articles, guides, or topics..."
            className="w-full px-4 py-3 text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-0 text-lg rounded-lg"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <button 
            onClick={handleSearchScroll}
            className="hidden sm:block bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-3 rounded-lg font-medium transition-colors"
          >
            Search
          </button>
        </div>
      </div>

      {/* --- BLOG GRID SECTION (RESTORED EXACTLY) --- */}
      <div ref={resultsRef} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="flex justify-between items-end mb-12">
          <div>
            <h2 className="text-3xl font-bold text-gray-900">Latest Updates</h2>
            <p className="text-gray-600 mt-2 text-lg">Dive into bulk messaging topics, explore industry trends, and learn how impactful SMS communication strengthens your bottom line.</p>
          </div>
        </div>

        {filteredPosts.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
            {filteredPosts.map((post) => (
              <article 
                key={post.id} 
                className="group bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
              >
                <div className="relative h-48 overflow-hidden">
                  <img src={post.image} alt={post.title} className="w-full h-full object-cover transform transition-transform duration-500" />
                  <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-indigo-600 uppercase tracking-wide">
                    {post.category}
                  </div>
                </div>

                <div className="p-6">
                  <div className="flex items-center text-gray-400 text-xs mb-4 space-x-4">
                    <div className="flex items-center"><Calendar size={14} className="mr-1" /> {post.date}</div>
                    <div className="flex items-center"><Clock size={14} className="mr-1" /> {post.readTime}</div>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-indigo-600 transition-colors line-clamp-2">{post.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed mb-6 line-clamp-3">{post.excerpt}</p>
                  <div className="flex items-center justify-between border-t border-gray-100 pt-4">
                    <div className="flex items-center">
                      <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-500"><User size={16} /></div>
                      <span className="ml-2 text-sm font-medium text-gray-700">{post.author}</span>
                    </div>
                    <button onClick={() => setSelectedPost(post)} className="text-indigo-600 font-semibold text-sm flex items-center hover:translate-x-1 transition-transform">
                      Read More <ArrowRight size={16} className="ml-1" />
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <h3 className="text-xl text-gray-600">No articles found matching "{searchTerm}"</h3>
          </div>
        )}
      </div>

      {/* --- NEWSLETTER SECTION (RESTORED EXACTLY) --- */}
      <div className="bg-indigo-900 py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Subscribe to our newsletter</h2>
          <p className="text-indigo-200 mb-8">Get the latest SMS marketing tips and industry news delivered to your inbox.</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center max-w-lg mx-auto">
            <input type="email" placeholder="Enter your email" className="px-5 py-3 rounded-lg text-gray-900 focus:outline-none w-full" />
            <button className="bg-white text-indigo-900 font-bold px-8 py-3 rounded-lg hover:bg-indigo-50 transition-colors">Subscribe</button>
          </div>
        </div>
      </div>

      {/* --- MODAL POPUP --- */}
      {selectedPost && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
          <div className="absolute inset-0" onClick={() => setSelectedPost(null)}></div>
          <div className="relative bg-white w-full max-w-4xl max-h-[90vh] rounded-3xl overflow-hidden shadow-2xl flex flex-col">
            <button onClick={() => setSelectedPost(null)} className="absolute top-4 right-4 z-[110] bg-gray-100 hover:bg-gray-200 text-gray-800 p-2 rounded-full transition-all">
              <X size={24} />
            </button>
            <div className="overflow-y-auto">
              <div className="w-full h-64 md:h-96">
                <img src={selectedPost.image} alt={selectedPost.title} className="w-full h-full object-cover" />
              </div>
              <div className="p-6 md:p-10">
                <span className="bg-indigo-600 text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-widest">{selectedPost.category}</span>
                <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mt-4 leading-tight">{selectedPost.title}</h2>
                <div className="flex flex-wrap items-center gap-6 text-sm text-gray-500 my-6 pb-6 border-b border-gray-100">
                  <div className="flex items-center gap-2 font-medium text-gray-700"><User size={18}/> {selectedPost.author}</div>
                  <div className="flex items-center gap-2"><Calendar size={18} /> {selectedPost.date}</div>
                  <div className="flex items-center gap-2"><Clock size={18} /> {selectedPost.readTime}</div>
                </div>
                <div className="space-y-8">
                  <p className="text-lg text-gray-600 leading-relaxed">{selectedPost.excerpt}</p>
                  <section>
                    <h4 className="text-xl font-bold text-gray-900 mb-2">{selectedPost.content.sub1}</h4>
                    <p className="text-gray-700 leading-relaxed">{selectedPost.content.body1}</p>
                  </section>
                  <section>
                    <h4 className="text-xl font-bold text-gray-900 mb-2">{selectedPost.content.sub2}</h4>
                    <p className="text-gray-700 leading-relaxed">{selectedPost.content.body2}</p>
                  </section>
                  <section>
                    <h4 className="text-xl font-bold text-gray-900 mb-2">{selectedPost.content.sub3}</h4>
                    <p className="text-gray-700 leading-relaxed">{selectedPost.content.body3}</p>
                  </section>
                  <section>
                    <h4 className="text-xl font-bold text-gray-900 mb-2">{selectedPost.content.sub4}</h4>
                    <p className="text-gray-700 leading-relaxed">{selectedPost.content.body4}</p>
                  </section>
                </div>
                <div className="mt-10 pt-6 border-t border-gray-100 flex justify-end">
                  <button onClick={() => setSelectedPost(null)} className="bg-indigo-600 text-white px-6 py-2 rounded-lg font-bold hover:bg-indigo-700 transition-all">Close</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}